<template>
    <div :class="phoneClass || 'retrieve'">
        <div class="retrieve-header">
            <IndexHeader></IndexHeader>
        </div>
        <div class="retrieve-section">
            <h1>{{$t('retrieve.retrieve_password')}}</h1>
            <div class="retrieve-section-cent">
                <p>{{$t('loginPage.email')}}</p>
                <el-input v-model="email" @change="check" :placeholder="$t('message.enter')"></el-input>
                <span disabled=false @click="codeTips">{{tips}}</span>
            </div>
            <div class="retrieve-section-cent">
                <p>{{$t('retrieve.verification_code')}}</p>
                <el-input v-model="code" :placeholder="$t('message.enter')"></el-input>
            </div>
            <div class="retrieve-section-cent">
                <p>{{$t('retrieve.new_password')}}</p>
                <el-input v-model="password" type="password" :placeholder="$t('message.enter')"></el-input>
            </div>
            <div class="retrieve-section-cent">
                <p>{{$t('retrieve.new_password_again')}}</p>
                <el-input v-model="passwordToo" type="password" :placeholder="$t('message.enter')"></el-input>
            </div>
            <div class="retrieve-section-cent" style="text-align: right">
                <el-button @click="push" type="success">{{$t('message.determine')}}</el-button>
                <el-button @click="goLogin" plain>{{$t('message.cancel')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import IndexHeader from './layout/header'
    import Core from "core/core";
    import {refresh} from "core/winSize"
    export default {
        data(){
            return {
	            phoneClass: '',
                email: '',
                tips: 'Click Send Verification Code',
                code: '',
                password: '',
                passwordToo: '',
                checkShow: true,
                timeName: '',
                sendTime: true,
                sendShow: false
            }
        },
        components: {
            IndexHeader
        },
        created(){

	        refresh(this,'phoneClass-retrieve');
	        window.onresize = function(){
		        setTimeout(function(){
			        refresh(this,'phoneClass-retrieve');
		        },10)
	        };
        },
        methods: {
            check(){
                if(this.email){
                    let email = this.email
	                let emailReg = Core.Const.EMAIL_REG
	                if( emailReg.test(email) ){
                        this.checkShow = false
                    } else {
                        this.checkShow = true
                        this.$message.error('邮箱格式不正确');
                    }
                } else {
                    this.checkShow = true
                    this.$message.error('请输入邮箱');
                }
            },
            codeTips(){
                if (this.sendTime){
                    this.check()
                    if (!this.checkShow){
                        this.sendTime = false
                        this.timer (10 , this.clearTimer)
                        Core.Email.Common.emailCodeSend(this.email).then((res)=>{
                        })
                    }
                } else {
                    this.$message.error("Frequent operation, please try again later");
                }
                // setInterval    window.clearInterval
            },
            timer(time , run){
                this.timeName = setInterval(()=>{
                    if (time >= 1){
                        time = time * 1 - 1
                        this.tips = "Please resend in "+ time +" seconds"
                    } else {
                        this.tips = "Click Send Verification Code"
                        this.sendTime = true
                        run()
                    }
                },1000)
            },
            clearTimer(){
                clearInterval(this.timeName)
            },
            push(){
                this.check()
                if(!this.checkShow){
                    if (this.checkPassword()){
                            if (this.code.length>0){
                                console.log("请求发出")
                                Core.Email.Common.emailCodeCheck(this.email,this.code,this.password).then((res)=>{
                                    this.$message.success('密码修改成功');
                                    this.goLogin()
                                    console.log(res)
                                })
                            } else {
                                this.$message.error('请输入验证码')
                            }
                    }
                }
            },
            checkPassword(){
                if (this.password.length>0 ){
                    if (!this.isStrongPassword(this.password)) {
                        this.$message.error('密码至少8位，且必须包含大小写字母、数字和特殊字符')
                        return false
                    }
                    if (this.passwordToo.length > 0) {
                        if(this.passwordToo === this.password ) {
                            return true
                        } else {
                            this.$message.error('两次密码输入不一致，请重新输入')
                        }
                    } else  {
                        this.$message.error('请再次输入密码')
                    }
                } else {
                    this.$message.error('请输入密码')
                }
            },
            // 校验密码强度：至少8位，包含大小写字母、数字和特殊字符
            isStrongPassword(password) {
                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(password)
            },
            goLogin(){
                this.$router.push('/login');

            }
        }

    }
</script>

<style scoped lang="scss">
    .retrieve {
        background: #E5EBEF;
        min-height: 100vh;
        text-align: center;
        .retrieve-section {
            padding: 40px;
            width: 430px;
            background: white;
            margin: 21px auto;
            text-align: left;
            border: 1px solid transparent;
            h1 {
                font-size: 24px;
            }
            .retrieve-section-cent {
                color: #7A8799;
                margin-top: 15px;
                >p {
                    margin-bottom: 5px;
                }
                .el-input__inner {
                    height: 40px;
                }
                >span {
                    cursor:pointer;
                    display: block;
                    color: blue;
                    font-size: 12px;
                    margin-top: 5px;
                }
            }
        }
    }
</style>
<style lang="scss">
    .retrieve{
        .retrieve-section{
            .retrieve-section-cent{
                .el-input__inner {
                    height: 35px;
                }
            }
        }
    }
    .phoneClass-retrieve {

        min-height: 100vh;
        background: #E5EBEF;
        .retrieve-section {
            width: 70%;
            margin: 30px auto;
            background: white;
            padding: 30px;
            >h1 {
                font-size: 24px;
            }
            .retrieve-section-cent {

                margin-top: 10px;
                >p {
                    color: #7A8799;
                }
                >span {
                    cursor: pointer;
                    display: block;
                    color: blue;
                    font-size: 12px;
                    margin-top: 5px;
                }
                .el-button {

                }
            }
        }
    }
</style>
